import $ from "../jquery_global";

window.AdminBatch = {
  handleProductList: (element_id) => {
    $(element_id).select2({
      minimumInputLength: 3,
      ajax: {
        url: "/admin/trace_products/list",
        dataType: 'json',
        delay: 300,
        type: "GET",
        processResults: function (data) {
          return {
            results: data.trace_products
          }
        }
      }
    })
  },

  setDefaultProduct: (element_id, id, text) => {
    var newOption = new Option(text, id, false, false)

    $(element_id).append(newOption)
    $(element_id).append(id);
    $(element_id).trigger('change')
  }
}
